import { Link } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'instant' }); 
  };

  return (
    <footer className="bg-[#1a1818] text-white pt-12 md:pt-16 pb-10 px-6 border-t-4 border-[#f9b50b]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
        
        {/* LEFT SECTION: SOCIAL ICONS */}
        {/* Mobile: Top order, Desktop: Left order */}
        <div className="flex gap-4 order-2 md:order-1 flex-1 justify-center md:justify-start">
          <a 
          href="https://www.facebook.com/ILinterfaith" 
          target="_blank" rel="noopener noreferrer"            
          className="w-10 h-10 border border-gray-700 flex items-center justify-center hover:bg-[#f9b50b] hover:border-[#f9b50b] hover:text-[#221f1f] transition-all">
            <FaFacebookF />
          </a>
          <a 
            href="https://www.linkedin.com/company/illinois-interfaith-organization-official/posts/?feedView=all"
            target="_blank" 
            rel="noopener noreferrer" 
            className="w-10 h-10 border border-gray-700 flex items-center justify-center hover:bg-[#f9b50b] hover:border-[#f9b50b] hover:text-[#221f1f] transition-all"
          >
            <FaLinkedinIn />
          </a>
          <a 
            href="https://www.instagram.com/illinoisinterfaithorg/"
            target="_blank" 
            rel="noopener noreferrer" 
            className="w-10 h-10 border border-gray-700 flex items-center justify-center hover:bg-[#f9b50b] hover:border-[#f9b50b] hover:text-[#221f1f] transition-all"
          >
            <FaInstagram />
          </a>
          <a 
            href="mailto:info@ilinterfaith.org"
            className="w-10 h-10 border border-gray-700 flex items-center justify-center hover:bg-[#f9b50b] hover:border-[#f9b50b] hover:text-[#221f1f] transition-all"
          >
            <FaEnvelope />
          </a>
        </div>

        {/* CENTER SECTION: LOGO + COPYRIGHT */}
        {/* Mobile: Center position, order-1 ensures it shows first on small screens */}
        <div className="flex flex-col items-center text-center order-1 md:order-2 flex-1">
          <img src="/logo.png" alt="Illinois Interfaith" className="h-12 md:h-14 w-auto mb-4" />
          
          <h3 className="text-lg md:text-xl font-serif font-bold uppercase tracking-tight mb-1">
            Illinois Interfaith Organization
          </h3>
          
          <p className="text-gray-500 text-[9px] md:text-[10px] uppercase tracking-[0.2em] mb-2 px-4 md:px-0">
            © 2026 Illinois Interfaith Organization. All rights reserved.
          </p>
          
          <div className="h-[1px] w-12 bg-[#f9b50b] mb-2"></div>
          
          <p className="text-[#f9b50b] font-bold uppercase tracking-[0.4em] text-[8px] md:text-[9px]">
            Unity in Diversity
          </p>
        </div>

        {/* RIGHT SECTION: SPECIFIC FOOTER LINKS */}
        {/* Mobile: Bottom order, wraps on small screens */}
        <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-4 order-3 flex-1">
          <Link to="/Events" onClick={handleLinkClick} className="text-[10px] md:text-[11px] font-bold uppercase tracking-widest hover:text-[#f9b50b] transition-colors">
            EVENTS
          </Link>
          <Link to="/about" onClick={handleLinkClick} className="text-[10px] md:text-[11px] font-bold uppercase tracking-widest hover:text-[#f9b50b] transition-colors">
            ABOUT US
          </Link>
          <Link to="/gallery" onClick={handleLinkClick} className="text-[10px] md:text-[11px] font-bold uppercase tracking-widest hover:text-[#f9b50b] transition-colors">
            GALLERY
          </Link>
          <Link to="/contact" onClick={handleLinkClick} className="text-[10px] md:text-[11px] font-bold uppercase tracking-widest hover:text-[#f9b50b] transition-colors">
            CONTACT
          </Link>
        </div>

      </div>
    </footer>
  );
};

export default Footer;